<template>
  <router-link :to="{ name: 'scenario-view', params: { uuidId: uuidId } }">
    <div class="mini-scenario d-flex justify-content-">
      <div class="text-center rounded d-flex align-items-center">
        <img :src="deviceThumb" title style="width:65px;" />
      </div>
      <div class="ml-4 d-flex align-content-center text-left">
        <h6 class="text-left mt-3">{{ name }}</h6>
      </div>
    </div>
  </router-link>
</template>

<script>
import ScenarioHelper from "@/utils/scenario.helper";

export default {
  name: "MiniScenario",
  props: [
    "uuidId",
    "deviceId",
    "name"
  ],
  data() {
    return {
      deviceThumb: require("../assets/device/" +
        ScenarioHelper.getFilenameForDeviceThumb(this.deviceId)),
    }
  }
};
</script>

<style scoped>
h6 {
  /* font-weight: 700; */
}

img {
  width: 20%;
  height: auto;
}

@media only screen and (max-width: 992px) {
  .mini-scenario {
    flex-direction: column;
    justify-content: center;
  }
}
</style>
